import styled from 'styled-components'

export const ChangeInputButton = styled.button`
  background: transparent;
  border: none;
  font-weight: bold;
  color: #989898;
  font-size: 22px;
  padding: 0 4px;
`

export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #989898;
  background-color: #fff;
  height: 32px;
  width: 52px;
  text-align: center;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`
